import "./Footer.css";
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__text">Developed by Ian Kamar</div>
      <div className="footer__year">2023</div>
    </footer>
  );
};

export default Footer;
